var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEventMarketingFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 240,
    height: 240,
    viewBox: "0 0 240 240",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_653_1227)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M186.267 187.779C173.377 193.348 150.914 191.403 141.293 189.734L159.439 205.612C172.892 208.678 187.362 204.334 192.915 201.779L186.267 187.779Z",
    fill: "#FC86A4",
    stroke: "#FC86A4",
    strokeWidth: 4.69286,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.769 161.971C147.238 165.725 129.431 164.396 112.511 161.971L125.103 174.016C145.814 178.146 172.188 177.536 181.261 175.346L174.769 161.971Z",
    fill: "#FC86A4",
    stroke: "#FC86A4",
    strokeWidth: 4.69286,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.194 135.221C134.255 137.724 105.681 133.605 83.9631 133.891L93.1924 143.825C142.937 150.082 153.782 147.136 169.53 146.562L163.194 135.221Z",
    fill: "#FC86A4",
    stroke: "#FC86A4",
    strokeWidth: 4.69286,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.3927 130.606L177.116 223.447",
    stroke: "#FC86A4",
    strokeWidth: 4.69286,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.111 208.637L143.026 83.1537",
    stroke: "#FC86A4",
    strokeWidth: 4.69286,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6091 103.155C45.8459 92.2567 77.0013 80.8635 102.89 113.557",
    stroke: "#FC86A4",
    strokeWidth: 3.91071,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.725 109.199C52.9845 104.478 45.2089 113.993 42.4164 120.724C42.034 121.647 42.5374 122.667 43.4719 123.019L51.4546 126.018C52.7069 126.489 54.0355 125.525 54.1519 124.192C54.9307 115.27 61.1039 113.095 65.665 113.167C66.8462 113.186 67.9285 112.299 67.9285 111.118V110.921C67.9285 110.15 67.4539 109.449 66.725 109.199Z",
    fill: "#FC86A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.458 72.1692C113.319 58.5268 120.438 48.9396 128.56 45.9155C129.408 45.5998 130.329 46.0303 130.721 46.846L135.695 57.207C136.275 58.4143 135.431 59.8237 134.106 60.0244C125.236 61.3686 123.115 66.5574 123.419 70.7523C123.503 71.9144 122.748 73.0593 121.589 73.1843L121.319 73.2136C120.538 73.2979 119.78 72.8854 119.458 72.1692Z",
    fill: "#FC86A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.3353 86.1808C28.7608 86.1808 29.9164 85.0252 29.9164 83.5997C29.9164 82.1743 28.7608 81.0187 27.3353 81.0187C25.9098 81.0187 24.7542 82.1743 24.7542 83.5997C24.7542 85.0252 25.9098 86.1808 27.3353 86.1808Z",
    fill: "#FC86A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.6758 204.896C82.0817 204.661 83.0305 203.33 82.7951 201.924C82.5596 200.518 81.229 199.569 79.8231 199.805C78.4172 200.04 77.4684 201.371 77.7038 202.777C77.9393 204.183 79.2699 205.132 80.6758 204.896Z",
    fill: "#FC86A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.402 153.136C223.827 153.136 224.983 151.98 224.983 150.555C224.983 149.129 223.827 147.974 222.402 147.974C220.976 147.974 219.82 149.129 219.82 150.555C219.82 151.98 220.976 153.136 222.402 153.136Z",
    fill: "#FC86A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5316 85.5548C35.2659 85.5548 35.8613 84.9595 35.8613 84.2252C35.8613 83.4908 35.2659 82.8955 34.5316 82.8955C33.7973 82.8955 33.202 83.4908 33.202 84.2252C33.202 84.9595 33.7973 85.5548 34.5316 85.5548Z",
    fill: "#FC86A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.6686 203.088C88.3928 202.966 88.8816 202.281 88.7603 201.557C88.639 200.833 87.9535 200.344 87.2293 200.465C86.505 200.586 86.0162 201.272 86.1376 201.996C86.2589 202.72 86.9443 203.209 87.6686 203.088Z",
    fill: "#FC86A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.242 49.4223C110.977 49.4223 111.572 48.827 111.572 48.0927C111.572 47.3584 110.977 46.7631 110.242 46.7631C109.508 46.7631 108.913 47.3584 108.913 48.0927C108.913 48.827 109.508 49.4223 110.242 49.4223Z",
    fill: "#FC86A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.522 56.9298C109.256 56.9298 109.851 56.3345 109.851 55.6002C109.851 54.8658 109.256 54.2705 108.522 54.2705C107.787 54.2705 107.192 54.8658 107.192 55.6002C107.192 56.3345 107.787 56.9298 108.522 56.9298Z",
    fill: "#FC86A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.5766 21.579C62.2181 21.579 63.5488 20.0732 63.5488 18.2158C63.5488 16.3583 62.2181 14.8525 60.5766 14.8525C58.9352 14.8525 57.6045 16.3583 57.6045 18.2158C57.6045 20.0732 58.9352 21.579 60.5766 21.579Z",
    fill: "#FC86A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.8238 44.7161C73.2423 43.6298 73.2547 41.2639 71.8516 39.4318C70.4485 37.5997 68.1612 36.9951 66.7428 38.0814C65.3243 39.1677 65.3119 41.5336 66.715 43.3657C68.1181 45.1978 70.4054 45.8024 71.8238 44.7161Z",
    fill: "#FC86A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.2958 45.6107C32.3049 43.2982 33.3327 39.4912 34.1457 37.4184C34.2592 37.1289 34.5853 36.9932 34.876 37.1035L40.6907 39.309C40.9409 39.4039 41.0943 39.657 41.0626 39.9228L40.3125 46.2241C40.274 46.5476 39.9777 46.7767 39.6549 46.7326L33.721 45.9211C33.5349 45.8956 33.3698 45.7833 33.2958 45.6107Z",
    fill: "#FC86A4",
    stroke: "#FC86A4",
    strokeWidth: 2.91362,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.878 13.0808C109.171 14.3463 108.302 17.5605 108.014 19.4183C107.973 19.6777 108.153 19.9154 108.412 19.9586L113.592 20.8226C113.815 20.8598 114.035 20.7404 114.125 20.5331L116.257 15.6174C116.367 15.365 116.248 15.0719 115.994 14.9668L111.32 13.0351C111.173 12.9745 111.005 12.9863 110.878 13.0808Z",
    fill: "#FC86A4",
    stroke: "#FC86A4",
    strokeWidth: 2.46026,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.001 57.3218C35.7296 65.9302 41.6775 76.6045 46.8727 81.4728C47.2891 81.863 47.9188 81.8858 48.385 81.5568L48.8349 81.2393C49.5326 80.7469 49.5382 79.7133 48.9444 79.0997C46.5951 76.6719 46.3519 73.8867 46.5764 72.6518C47.0769 66.3306 54.815 64.4387 58.856 65.2997C72.6055 68.2293 78.1296 79.2442 80.7568 85.9689C81.0176 86.6364 81.7775 86.961 82.4353 86.6764L83.338 86.2861C83.8095 86.0822 84.1139 85.6152 84.0351 85.1076C82.6856 76.4204 65.7703 46.4444 49.001 57.3218Z",
    fill: "#FC86A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.9016 164.854C38.8508 164.899 39.7569 162.103 39.9254 158.608C40.0938 155.114 39.4609 152.243 38.5117 152.198C37.5625 152.152 36.6564 154.948 36.4879 158.443C36.3195 161.938 36.9524 164.808 37.9016 164.854Z",
    fill: "#FC86A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.2665 180.573C38.2157 180.619 39.1218 177.823 39.2902 174.328C39.4587 170.833 38.8258 167.963 37.8766 167.917C36.9273 167.871 36.0213 170.667 35.8528 174.162C35.6843 177.657 36.3173 180.527 37.2665 180.573Z",
    fill: "#FC86A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4561 166.102C26.4104 167.051 28.5287 167.924 31.1876 168.053C33.8464 168.181 36.0389 167.515 36.0847 166.566C36.1304 165.617 34.0121 164.743 31.3533 164.615C28.6944 164.487 26.5019 165.153 26.4561 166.102Z",
    fill: "#FC86A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.5407 166.585C39.495 167.534 41.6133 168.408 44.2722 168.536C46.931 168.664 49.1235 167.998 49.1693 167.049C49.215 166.1 47.0967 165.226 44.4379 165.098C41.779 164.97 39.5865 165.636 39.5407 166.585Z",
    fill: "#FC86A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.111 38.318C163.903 38.3561 164.659 36.0238 164.799 33.1086C164.94 30.1935 164.412 27.7993 163.62 27.7611C162.828 27.723 162.073 30.0552 161.932 32.9704C161.791 35.8856 162.319 38.2798 163.111 38.318Z",
    fill: "#FC86A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.581 51.4339C163.373 51.4721 164.129 49.1398 164.269 46.2246C164.41 43.3094 163.882 40.9153 163.09 40.8771C162.298 40.8389 161.542 43.1712 161.402 46.0864C161.261 49.0016 161.789 51.3958 162.581 51.4339Z",
    fill: "#FC86A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.564 39.3618C153.526 40.1536 155.293 40.8821 157.511 40.989C159.729 41.0959 161.557 40.5407 161.596 39.7489C161.634 38.9572 159.867 38.2286 157.649 38.1217C155.431 38.0148 153.602 38.57 153.564 39.3618Z",
    fill: "#FC86A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.478 39.76C164.44 40.5518 166.207 41.2803 168.425 41.3872C170.643 41.4941 172.472 40.9389 172.51 40.1471C172.548 39.3554 170.781 38.6268 168.563 38.5199C166.345 38.413 164.516 38.9682 164.478 39.76Z",
    fill: "#FC86A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.547 91.6446C190.339 91.6828 191.095 89.3505 191.235 86.4353C191.376 83.5201 190.848 81.126 190.056 81.0878C189.264 81.0496 188.509 83.3819 188.368 86.2971C188.228 89.2123 188.756 91.6065 189.547 91.6446Z",
    fill: "#FC86A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.018 104.757C189.809 104.795 190.565 102.463 190.706 99.5476C190.846 96.6324 190.318 94.2383 189.527 94.2001C188.735 94.1619 187.979 96.4942 187.839 99.4094C187.698 102.325 188.226 104.719 189.018 104.757Z",
    fill: "#FC86A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180 92.681C179.962 93.4728 181.729 94.2013 183.946 94.3082C186.164 94.4151 187.993 93.8599 188.031 93.0682C188.069 92.2764 186.302 91.5479 184.085 91.4409C181.867 91.334 180.038 91.8892 180 92.681Z",
    fill: "#FC86A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.916 93.0793C190.877 93.8711 192.644 94.5996 194.862 94.7065C197.08 94.8135 198.909 94.2583 198.947 93.4665C198.985 92.6747 197.218 91.9462 195.001 91.8393C192.783 91.7324 190.954 92.2876 190.916 93.0793Z",
    fill: "#FC86A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.596 86.3296C222.633 86.3602 223.729 77.7044 224.045 66.9963C224.361 56.2882 223.777 47.5828 222.741 47.5522C221.704 47.5216 220.608 56.1774 220.292 66.8855C219.976 77.5936 220.56 86.299 221.596 86.3296Z",
    fill: "#FC86A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.607 66.6046C209.461 67.6311 215.254 69.3026 222.547 70.3382C229.839 71.3738 235.868 71.3813 236.014 70.3548C236.16 69.3284 230.367 67.6568 223.074 66.6212C215.782 65.5857 209.753 65.5782 209.607 66.6046Z",
    fill: "#FC86A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.152 76.2155C213.874 76.9598 218.746 73.4072 224.034 68.2805C229.322 63.1538 233.024 58.3944 232.303 57.65C231.581 56.9057 226.709 60.4583 221.421 65.585C216.132 70.7117 212.431 75.4711 213.152 76.2155Z",
    fill: "#FC86A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.301 77.7826C231.579 78.527 226.707 74.9744 221.419 69.8476C216.131 64.7209 212.429 59.9615 213.151 59.2171C213.872 58.4728 218.744 62.0254 224.032 67.1521C229.321 72.2788 233.023 77.0383 232.301 77.7826Z",
    fill: "#FC86A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.4991 18.835C92.6183 21.5985 98.7452 32.7727 90.298 55.361C88.9282 59.0218 88.6666 67.1152 97.1413 72.6531C98.8429 73.765 99.9761 75.619 100.166 77.6429C100.846 84.8797 104.665 97.1919 116.5 106.904",
    stroke: "#FC86A4",
    strokeWidth: 7.665,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.9517 105.735C79.2176 114.547 66.4115 132.171 85.0577 132.171C103.704 132.171 126.981 111.836 136.288 101.668C142.076 94.1854 149.694 78.9544 133.863 77.8907C118.033 76.827 103.177 89.8054 97.7285 96.4275",
    stroke: "#FC86A4",
    strokeWidth: 4.69286,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.428 101.119C145.674 102.683 139.26 101.77 136.523 101.119L119.316 117.544C131.83 118.983 152.322 120.62 158.501 120.594L149.428 101.119Z",
    fill: "#FC86A4",
    stroke: "#FC86A4",
    strokeWidth: 4.69286,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.681 214.215C187.425 217.594 177.168 219.273 171.798 218.204C178.117 229.78 184.886 227.094 188.379 225.791C200.268 220.551 198.86 212.99 197.139 207.802L188.379 202.952L192.681 214.215Z",
    fill: "#FC86A4",
    stroke: "#FC86A4",
    strokeWidth: 2.19,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_653_1227"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 240,
    height: 240,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEventMarketingFilled);
export default __webpack_public_path__ + "static/media/event-marketing-filled.0428e037355c1552e8cf282b65e557b2.svg";
export { ForwardRef as ReactComponent };